export const fieldTypes = {
  TEXT: "text",
  NUMBER: "number",
  SELECT: "select",
  DATE: "date",
  DATE_TIME: "dateTime",
  CHECKBOX: "checkbox"
};
